type NewsletterApiFetcherArgs = {
  method?: 'GET' | 'POST';
  path?: `/${string}`;
  sig: string;
};

type NewsletterApiResponse = {
  id: string;
  subscribed: boolean;
  status: string;
  message: string;
};

type NewsletterApiFetcher = (
  args: NewsletterApiFetcherArgs,
) => Promise<NewsletterApiResponse>;

const createNewsletterApiFetcher = (
  baseUrl: string,
  disableCache: boolean,
): NewsletterApiFetcher => {
  return async ({
    method = 'GET',
    path,
    sig,
  }: NewsletterApiFetcherArgs): Promise<NewsletterApiResponse> => {
    const url = new URL(`${baseUrl}${path}`);

    if (disableCache) {
      url.searchParams.set('disableCache', 'true');
    }

    const options: RequestInit = {
      method,
      mode: 'cors',
      headers: {
        'x-spid-sig': sig,
      },
    };

    const response = await fetch(url.toString(), options);

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }

    return response.json();
  };
};

export { createNewsletterApiFetcher };
